import { ChatHistoryMessage } from 'api/queries/chat/types'
import { ChatAttachment, ChatMessage, ChatRole } from 'types/Chat'

const createPendingMessage = (
  role: ChatRole,
  content: string,
  attachments?: ChatAttachment[],
): ChatMessage => ({
  id: `pending-${role}-${Date.now()}`,
  role,
  content,
  createdAt: Date.now(),
  isStreaming: role === 'assistant',
  attachments,
})

const fromHistoryMessage = (message: ChatHistoryMessage): ChatMessage => ({
  ...message,
  isStreaming: false,
  attachments: message.attachments?.map(({ name, mimeType, sizeBytes }, index) => ({
    id: `${message.id}-${index}`,
    name,
    type: mimeType,
    size: sizeBytes,
  })),
})

export { createPendingMessage, fromHistoryMessage }
